import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/settings/app.scss';
import {Route, Routes} from "react-router-dom";
import Page from "./pages/schemaPages/Page";
import {paths} from "./storage/paths";
import HomePage from "./pages/HomePage";
import ServicesPage from "./pages/ServicesPage";
import ShopPage from "./pages/ShopPage";
import ContactPage from "./pages/ContactPage";
import CartPage from "./pages/CartPage";

function App() {
  return (
      <Routes>
        <Route path={paths.home} element={<Page><HomePage/></Page>} />
        <Route path={paths.services} element={<Page><ServicesPage/></Page>} />
        <Route path={paths.shop} element={<Page><ShopPage/></Page>} />
        <Route path={paths.contact} element={<Page><ContactPage/></Page>} />
        <Route path={paths.cart} element={<Page><CartPage/></Page>} />

        {/*<Route path={paths.reviews} element={<Page><ReviewsPage/></Page>} />*/}
        {/*<Route path={paths.writeReview} element={<Page><WriteReviewPage/></Page>} />*/}

        <Route path={paths.undefined} element={<Page><HomePage/></Page>} />
      </Routes>
  );
}

export default App;